import { AfterViewInit, Component } from '@angular/core';
import { PunchoutOrderIntakeStatus } from '../../../../models/punchout';
import { punchoutIntakeStatusBadgeClass } from '../../../../utils/punchout-audit-utils';
import { PunchoutAuditTableBase } from '../punchout-audit-table.base';

/** Table layout for the order requests audit list. */
@Component({
  selector: 'lib-gung-settings-punchout-order-requests-table',
  templateUrl: './gung-settings-punchout-order-requests-table.component.html',
  styleUrl: './gung-settings-punchout-order-requests-table.component.scss',
  standalone: false
})
export class GungSettingsPunchoutOrderRequestsTableComponent extends PunchoutAuditTableBase implements AfterViewInit {
  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  statusClass(status?: PunchoutOrderIntakeStatus): string {
    return punchoutIntakeStatusBadgeClass(status);
  }
}
